import {css} from 'lit';

import {defaultStyles} from '../../../components/embed.js';

export const styles = defaultStyles.extends({
  statics: css``,
});

export default {styles};
